<template>
  <!--
    เครื่องพิมพ์ของ "เครื่องนี้" (utils/printerSettings.js) — ไม่ใช่ค่าของร้านเหมือนการ์ดอื่นในหน้านี้
    วางไว้ที่นี่เพราะคนหาตั้งค่าเครื่องพิมพ์ในหน้าตั้งค่าเป็นอันดับแรก กดแล้วเปิด offcanvas
    ตัวเดียวกับไอคอนที่แถบบน (layout เป็นคน mount) — แพทเทิร์นการ์ดเดียวกับ TaxSettingsCard

    เบราว์เซอร์ที่พิมพ์ตรงไม่ได้เลย (iPhone/iPad) → การ์ดเหลือแค่คำอธิบาย กดไม่ได้
    (ไอคอนที่แถบบนก็ซ่อน) — ยังโชว์ไว้ให้เจ้าของที่เปิดจาก iPad รู้ว่าทำไมตั้งค่าไม่ได้
  -->
  <div
    class="card mx-3 mt-3 mb-3"
    :role="canDirectPrint ? 'button' : null"
    @click="canDirectPrint && openPrinterSettings()"
  >
    <div class="card-body d-flex justify-content-between align-items-center py-3">
      <div>
        <div class="fw-semibold">
          <i class="fa-solid fa-print me-2 text-primary" />
          {{ $t('_printer.Printer on this device') }}
        </div>
        <div class="text-muted" style="font-size: 13px;">
          {{ summary }}
        </div>
        <div v-if="canDirectPrint && !settings.configured" class="text-warning-emphasis mt-1" style="font-size: 13px;">
          <i class="fa-solid fa-triangle-exclamation me-1" />
          {{ $t('_printer.This device has not been set up yet') }}
        </div>
      </div>
      <i v-if="canDirectPrint" class="fa-solid fa-chevron-right text-muted" />
    </div>
  </div>
</template>

<script lang="js">
import { printerSettings, openPrinterSettings, canDirectPrint } from '@/utils/printerSettings';

export default {
  name: 'PrinterSettingsCard',
  data() {
    return { settings: printerSettings, canDirectPrint: canDirectPrint() };
  },
  computed: {
    summary() {
      if (!this.canDirectPrint) {
        return this.$t('_printer.This browser cannot print directly (iPhone or iPad) - receipts open as PDF and can be printed with AirPrint');
      }
      if (!this.settings.configured) {
        return this.$t('_printer.Paper size and cash drawer are set per device - each till or tablet sets up its own');
      }
      if (this.settings.transport === 'none') {
        return this.$t('_printer.No printer - receipts open as PDF') + ' · ' + this.settings.paperWidth;
      }
      return [
        this.$t(this.settings.transport === 'bluetooth' ? '_printer.Bluetooth printer' : '_printer.USB printer'),
        this.settings.paperWidth,
        this.settings.cashDrawer ? this.$t('_printer.With cash drawer') : this.$t('_printer.No cash drawer'),
      ].join(' · ');
    },
  },
  methods: {
    openPrinterSettings,
  },
};
</script>
